<template>
  <footer class="footer">
    <div class="footer-inner container">
      <div class="row row-footer">
        <div class="col d-flex flex-column align-items-start">
          <img
            class="footer-logo mb-3"
            :src="$getFileSource(path)"
            :alt="$store.state.app.settings.websiteName"
          />
          <div class="d-flex social-icons-margin flex-row align-items-center justify-content-center">
            <link-wrapper
              v-for="social in contactInfo.socials"
              :key="social.icon"
              :external="true"
              :location="social.location"
            >
              <div class="social-icon-wrapper rounded-circle d-flex align-items-center justify-content-center mx-1">
                <font-awesome-icon
                  class="social-icon"
                  :icon="['fab', social.icon]"
                />
              </div>
            </link-wrapper>
          </div>
        </div>

        <FooterSectionLinks v-bind="footerLinks1" />
        <FooterSectionLinks v-bind="footerLinks2" />

        <div class="col newsletter-col">
          <h6 class="subscribe fs-4 fw-bold">{{$t('common.subscribeNewsletter')}}</h6>
          <div class="newsletter-form d-flex">
            <input
              type="email"
              class="newsletter-input"
              :placeholder="$t('common.enterEmail')"
            />
            <button class="newsletter-submit">
              {{$t('common.submit')}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="footer-bottom__content">
          <img
            class="footer-bottom__badge"
            :src="pnrrBadgeUrl"
            alt="PNRR – Next Generation EU"
          />
          <div class="footer-bottom__text">
            <p class="footer-bottom__copy">
              Copyright ©️ 2025 Maestri Aritfex Via Ricasoli 59R - 50122 Firenze | C.F. 94303850484 | All rights reserved
            </p>
            <p class="footer-bottom__pnrr">
              PNRR – Piano Nazionale di Ripresa e Resilienza – Progetto TOCC0002055 – Decreto Direttoriale n. 385 del 19/10/2022 – Sub-investimento 3.3.2 “Sostegno ai settori culturali e creativi per l’innovazione e la transizione digitale (Azione A II)” – finanziato dall’Unione europea – Next Generation EU.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import FooterSectionLinks from "../../atoms/TitleWithHorizontalLinksList/TitleWithHorizontalLinksList.vue";
import { footerLinks1 } from "../../../data/footerLinks.json";
import { footerLinks2 } from "../../../data/footerLinks.json";
import LinkWrapper from "../../atoms/LinkWrapper/LinkWrapper.vue";
import { CONTACT_INFO } from "@/constents/contactInfo";

export default {
  components: { FooterSectionLinks, LinkWrapper },
  data() {
    return {
      footerLinks1,
      footerLinks2,
      path: "images/logos/logo-viabrera.png",
      pnrrBadgePath: "images/footer/Logo-TOCC.jpg",
      contactInfo: CONTACT_INFO,
    };
  },
  computed: {
    pnrrBadgeUrl() {
      return this.$getFileSource(this.pnrrBadgePath);
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: #000000;
  color: #ffffff;
  padding: 60px 0 0;
  display: flex;
  flex-direction: column;
}

.footer-inner {
  width: 100%;
  flex: 1 0 auto;
  padding-bottom: 60px;
}

.footer-logo {
  width: 189px;
  filter: brightness(0) invert(1);
  margin-left: auto;
}

.social-icon-wrapper {
  width: 34px;
  height: 34px;
  background-color: #ffffff;
  transition: all 0.3s ease;
}

.social-icon-wrapper:hover {
  transform: translateY(-2px);
}

.social-icon {
  color: #000000 !important;
  font-size: 18px;
}

.social-icons-margin {
  margin-left: 160px;
}

.subscribe {
  color: #ffffff;
  margin-right: 30px !important;
}

.newsletter-col {
  color: #ffffff;
}

.newsletter-form {
  position: relative;
  width: 250px;
  margin-top: 14px;
}

.newsletter-input {
  height: 38px;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 999px;
  padding: 0 80px 0 16px;
  font-size: 14px;
  outline: none;
  color: #333;
  box-sizing: border-box;
}

.newsletter-submit {
  position: absolute;
  top: 0;
  right: 0;
  height: 38px;
  width: 70px;
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.newsletter-submit:hover {
  background-color: #333333;
}

.footer-bottom {
  background-color: #f8f8f8;
  color: #000000;
  padding: 24px 0;
}

.footer-bottom__content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-bottom__badge {
  width: 220px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.footer-bottom__text {
  max-width: 960px;
}

.footer-bottom__copy,
.footer-bottom__pnrr {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.5;
}

.menu-search span {
  font-size: 13px;
}

@media (max-width: 992px) {
  .social-icons-margin {
    margin-left: 80px;
  }
}

@media (max-width: 767.98px) {
  .footer-inner .row {
    display: block !important;
  }

  .footer-inner .col {
    margin-top: 24px;
  }

  .newsletter-form {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .social-icons-margin {
    margin-left: 0;
  }

  .footer-bottom__content {
    text-align: center;
  }

  .footer-bottom__text {
    max-width: 100%;
  }
}
</style>
